var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2693 10.9088V6.54538C16.2693 2.93177 13.322 0 9.68424 0C6.04753 0 3.0992 2.93177 3.0992 6.54538V10.9088H0.904053V24H18.465V10.9088H16.2693ZM5.29354 6.54498C5.29354 4.13943 7.26371 2.18153 9.68344 2.18153C12.1044 2.18153 14.0733 4.13983 14.0733 6.54498V10.9084L5.29354 10.9088V6.54498Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.231bf3a98d94a6887013c80196b6bbb7.svg";
export { ForwardRef as ReactComponent };